import { render, staticRenderFns } from "./FolderSendMailDialog.vue?vue&type=template&id=658d23cd&scoped=true"
import script from "./FolderSendMailDialog.vue?vue&type=script&lang=js"
export * from "./FolderSendMailDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderSendMailDialog.vue?vue&type=style&index=0&id=658d23cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658d23cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VChip,VCombobox})
